export function D(str) {
  if (!str) return []
  return str.split(' ').map((x) => {
    const tile = { code: x.slice(0, 2) }
    const flags = x.slice(2)
    if (flags.includes('r')) tile.rotated = true
    if (flags.includes('!')) tile.highlight = true
    return tile
  })
}

export function fmt(n) {
  return n.toLocaleString('en-US')
}

export function backs(n) {
  return Array.from({ length: n }, () => ({ code: 'xx' }))
}

export function applyHandHighlights(hand, hlCodes) {
  const hl = (hlCodes || []).slice()
  return hand.map((code) => {
    const k = hl.indexOf(code)
    if (k > -1) {
      hl.splice(k, 1)
      return { code, highlight: true }
    }
    return { code }
  })
}
